



import ENV_PARAMS from '@/constants/envParams';
import { RPCEndpointKey, SUPPORT_RPC_ENDPOINT } from '@/constants/settings'

type TCacheData = {
  value: any,     // 数据值
  expired: number | undefined,  // 过期时间(undefined永不过期)
}

export class DataCache extends Map {
  constructor() {
    super();
  }

  public setValue(key: string, value: any, validTime?: number) {
    let expired;
    if (validTime && validTime > 0) {
      expired = validTime + Date.now();
    }
    const data: TCacheData = {
      value: value,
      expired: expired,
    }
    return super.set(key, data);
  }

  public getValue(key: string) {
    const data: TCacheData = super.get(key);
    if(!data){
      return undefined;
    } else if (!data.expired || data.expired > Date.now()){
      return data.value;
    } else {
      super.delete(key);
      return undefined;
    }
  }
}

// const DATA_CACHE = new DataCache();

export const fetcher = async (
  url: string,
  options: RequestInit = {},
  timeout: number = 60000
): Promise<any> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  const defaultOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  }
  const response = await fetch(url, {
    mode: "cors",
    ...defaultOptions,
    ...options,
    signal: controller.signal,
  }).then((resp) => {
    if (resp.ok) {
      try {
        return resp.json();
      } catch (e) {
        return resp;
      }
    } else {
      throw new Error(`HTTP error! status: ${resp.status}`);
    }
  });
  clearTimeout(timeoutId);
  return response;
}

export const fetchQuiknodePriorityFees = async (
  account?: string,
  endpoint?: string,
  lastBlocks?: number,
  apiVersion?: string
): Promise<any> => {
  const quiknodeRpc = SUPPORT_RPC_ENDPOINT.find((item) => item.key === RPCEndpointKey.QuiknodeRPC)
  const rpcUrl = endpoint ?? quiknodeRpc?.url
  if (!rpcUrl) {
    throw new Error('RPC url is undefined')
  }
  // Only include params that are defined
  const params = {
    'account': account,
    'last_n_blocks': lastBlocks,
    'api_version': apiVersion
  }
  const payload = {
    method: 'qn_estimatePriorityFees',
    params: JSON.parse(JSON.stringify(params)),
    id: 1,
    jsonrpc: '2.0',
  };
  const data = await fetcher(
    rpcUrl,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }, 10000
  );
  return data.result;
}

export async function fetchHeliusPriorityFees(
  account?: string,
  endpoint?: string
): Promise<any> {
  const payload = {
    'jsonrpc': "2.0",
    'id': "1",
    'method': "getPriorityFeeEstimate",
    'params': [{
      "accountKeys": account ? [account] : [],
      "options": {
        "includeAllPriorityFeeLevels": true
      }
    }]
  }
  const data = await fetcher(
    endpoint ?? ENV_PARAMS.HELIUS_RPC_URL,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    10000
  );
  return data.result;
}

// 上报交易哈希
export async function reportTxHash(
  data: {
    txId: string,
    programId?: string
  }
) {
  const resp = await fetcher(
    `${import.meta.env.VITE_API_TARGET_URL}/api/trade/report/hash`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    },
  );
  return resp;
}

// export const fetchTokenPrice = async (
//   ids: string,
//   currency?: string
// ): Promise<any> => {
//   const api = 'https://api.openhub.network/binance/api/v3/ticker/price?symbols=["SOLUSDT"]'
//   // const params = JSON.parse(JSON.stringify({
//   //   symbols: '["SOLUSDT"]',
//   // }))
//   // const api = 'https://api.coingecko.com/api/v3/simple/price';
//   // const querys = encodeURIComponent(new URLSearchParams(params).toString());
//   // const url = `${api}?${querys}`;
//   const url = api;
//   const data = await fetcher(url, {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//     }
//   }, 10000);
//   console.log('data=====', data)
//   // return data.result;
//   return new Promise((resolve) => {
//     window.setTimeout(() => {
//       resolve({
//         "solana": {
//           "usd": 138.36
//         }
//       })
//     }, 2000)
//   })
// }

// export const fetchSolPrice = async (nocache?: boolean): Promise<any> => {
//   const cacheKey = 'solPrice';
//   let value;
//   if (!nocache) {
//     value = DATA_CACHE.getValue(cacheKey);
//   }
//   if (value === undefined) {
//     const resp = await fetchTokenPrice('solana');
//     const price = resp.solana?.usd;
//     if (price != undefined) {
//       value = price
//       DATA_CACHE.setValue(cacheKey, price, 10000);
//     }
//   }
//   return value;
// }